<template>
    <v-dialog 
        v-model="type.dialog"  
        width="60%"
        
        @click:outside="type.dialog = false"
    >
        <v-card outlined>
            <v-img
                :src='type.src'
                height='400px'
                contain
                class='align-top'
            >
                <v-card-actions>
                    <GuidanceTag :type='type' :large='true'/>
                </v-card-actions> 
            </v-img>
            <v-card-title><span class='headline my-2'> {{ type.name }} </span></v-card-title>
            <v-card-subtitle> {{ type.subtitle }}</v-card-subtitle>
            <v-card-subtitle> {{ type.description }} </v-card-subtitle>
            <v-card-actions>
                <v-card 
                    outlined
                    class="mx-auto my-4"
                    width='40%'
                >
                    <v-card-title class="justify-center" >
                      {{ type.totalCarbon}} 
                      <sub><small>{{type.units}}</small></sub>
                    </v-card-title>
                    <v-card-subtitle class="text-center">Total {{ type.scope }} Equivalent</v-card-subtitle>
                </v-card>
            </v-card-actions>
            <v-card-text>
                <v-row>
                    <v-flex sm12 lg12 xl6 class="mx-auto">
                        <v-col>
                            <v-card outlined>
                                <v-card-title class='headline justify-center my-4'>by Material</v-card-title>
                                <v-card-actions class='justify-center'>
                                    <TypeMaterialChart 
                                        :type='type'
                                    />
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-flex>
                    <v-flex sm12 lg12 xl6 class="mx-auto">
                        <v-col>
                            <v-card outlined>
                                <v-card-title class='headline justify-center my-4'>by Element</v-card-title>
                                <v-card-actions class='justify-center'>
                                    <TypeElementChart 
                                        :type='type'
                                    />
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-flex>  
                </v-row>
                <v-row>
                    <v-flex sm12 lg12 xl6 class="mx-auto">
                        <v-col>
                            <v-card outlined height='100%'>
                                <v-card-title class='headline justify-center my-4'>by Stage</v-card-title>
                                <v-card-actions class='justify-center'>
                                    <TypeCarbonChart 
                                        :type='type'
                                    />
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-flex>
                    <v-flex sm12 lg12 xl6 class="mx-auto">
                        <v-col>
                            <v-card outlined height='100%'>
                                <v-card-title class='headline justify-center my-4'>Design Assumptions</v-card-title>
                                <v-card-actions>
                                    <TypeDesignAssumptions :type='type' />
                                </v-card-actions>
                            </v-card>
                        </v-col>
                    </v-flex>
                </v-row>                
            </v-card-text>
            <v-card-actions>
                <type-dialog-references :type='type' />
            </v-card-actions>   
            <v-card-actions>
                <DialogTag :type='type'/>
            </v-card-actions>
            <v-card-actions>
                <v-row dense>
                    <v-col align='center'>
                        <v-chip
                        v-for='name in type.authors'
                        :key='name'
                        outlined
                        color = 'tertiary darken-4'
                        class='mx-1 my-2'
                        >{{ name }}</v-chip>
                    </v-col>
                  </v-row>
            </v-card-actions>
            
            <v-card-actions>
                <v-btn 
                    color="secondary" 
                    text 
                    @click.stop="type.dialog = false"   
                >
                    close
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import TypeCarbonChart from '@/components/TypeCarbonChart'
import TypeMaterialChart from '@/components/TypeMaterialChart'
import TypeElementChart from '@/components/TypeElementChart'
import DialogTag from '@/components/DialogTag'
import GuidanceTag from '@/components/GuidanceTag'
import TypeDesignAssumptions from '@/components/TypeDesignAssumptions'
import TypeDialogReferences from '@/components/TypeDialogReferences'

export default {
    components: {
        TypeCarbonChart,
        TypeMaterialChart,
        TypeElementChart,
        DialogTag,
        GuidanceTag,
        TypeDesignAssumptions,
        TypeDialogReferences
    },

    props: {
        type: Object
    },

    data: () => {
        return{
            
        }        
    },

    methods: {  },
    
}
</script>